import { Path } from '@/main/router/routerPath';

import External from './External.vue';

export const router = new Path('/OjeteVozy/*', External, 'OV_OjeteVozy');
